import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { CompletionSlideProps } from './slideTypes';
import { COMPLETION_PHRASES, SLIDE_TITLE_SIZE, SLIDE_TEXT_SIZE } from './slideConstants';
import Button, { ButtonType } from '@/components/Button';
import Text from '@/components/Text';

export function CompletionSlide({ isFinalLesson, stockName, nextLessonTitle, isIndustry, slide, ticker }: CompletionSlideProps) {
  const router = useRouter();
  const [completionPhrase] = useState(() =>
    COMPLETION_PHRASES[Math.floor(Math.random() * COMPLETION_PHRASES.length)]
  );

  const handleExploreMore = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    slide.onComplete?.();
  };

  const handleStartTrading = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (ticker) {
      router.push(`/asset/${ticker}`).catch(() => {});
    }
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4 md:gap-6 w-full px-4 md:px-6 py-6 md:py-8 text-center flex-1">
      <div className="w-24 h-24 md:w-32 md:h-32 flex items-center justify-center">
        <img src="https://cdn.bloomapp.com/chatbot/new-floating-ollie.png" alt="Ollie" className="w-full h-full object-contain drop-shadow-2xl" />
      </div>
      
      <div className="flex flex-col gap-2 md:gap-3 text-center max-w-md">
        <Text size={SLIDE_TITLE_SIZE} className="font-normal text-white leading-tight text-center text-lg md:text-3xl">
          {isFinalLesson ? 'Woohoo!' : 'Great work!'}
        </Text>
        
        <Text size={SLIDE_TEXT_SIZE} className="text-white/90 leading-relaxed text-center text-sm md:text-2xl">
          {completionPhrase}
        </Text>

        {isFinalLesson && (
          <Text size="xs" className="text-white/50 mt-1 md:mt-2 leading-relaxed uppercase tracking-widest text-center text-[10px] md:text-sm">
            {isIndustry 
              ? `Course Completed! You learned about ${stockName}.`
              : `Course Completed! Ready to trade ${stockName}?`}
          </Text>
        )}
      </div>

      <div className="mt-2 md:mt-4 flex flex-row gap-2 md:gap-4 justify-center items-center relative z-[100]">
        {!isFinalLesson ? (
          <>
            <Button 
              type={ButtonType.Primary}
              size="sm"
              className="whitespace-nowrap !bg-white !text-black hover:!bg-white/90 !h-9 md:!h-14 !text-xs md:!text-md !px-3 md:!px-8"
              onClick={handleExploreMore}
            >
              Explore more
            </Button>
            <Button 
              type={ButtonType.Primary}
              size="sm"
              className="whitespace-nowrap !bg-white !text-black hover:!bg-white/90 !h-9 md:!h-14 !text-xs md:!text-md !px-3 md:!px-8"
              onClick={handleStartTrading}
            >
              Start Trading
            </Button>
          </>
        ) : (
          <Button 
            type={ButtonType.Primary}
            size="sm"
            className="whitespace-nowrap !bg-white !text-black hover:!bg-white/90 !h-9 md:!h-14 !text-xs md:!text-md !px-3 md:!px-8"
            onClick={handleStartTrading}
          >
            Start Trading
          </Button>
        )}
      </div>
    </div>
  );
}
